import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MenuItem } from '@coin/admin/core/util';

@Component({
  selector: 'coin-a-app-cards',
  templateUrl: './app-cards.component.html',
  styleUrls: ['./app-cards.component.scss'],
  standalone: false
})
export class AppCardsComponent {
  @Input() menuItems: MenuItem[];
  @Input() type: 'primary' | 'secondary' = 'primary';
  @Input() translationPrefix: string;

  @Output() onOpenClicked: EventEmitter<MenuItem> = new EventEmitter<MenuItem>();

  public get activeMenuItems(): MenuItem[] {
    return this.menuItems?.filter(menuItem => menuItem.active);
  }
}
